/* ----- code generated do not modify ----- */
var components_combo_box_locale18 = {
  "buttonLabel": "Rodyti pasi\u016Blymus",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Yra ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " parinktis");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " parinktys (-i\u0173)");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "\u012Evesta grup\u0117 ".concat(args.groupTitle, ", su ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " parinktimi");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " parinktimis (-i\u0173)");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", pasirinkta",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Pasi\u016Blymai",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", pasirinkta");
  }
};

export { components_combo_box_locale18 as default };
//# sourceMappingURL=lt-LT.esm.js.map
